module.exports = __webpack_public_path__ + "static/img/我要典当banner.794cd77.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/我要典当banner.png
// module id = GX7O
// module chunks = 1